<template>
    <label class="base-checkbox">
      <input
        type="checkbox"
        v-bind="$attrs"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <span class="checkmark"></span>
      <slot />
    </label>
  </template>
  
  <script>
  export default {
    name: 'BaseCheckbox',
    props: {
      modelValue: Boolean
    }
  }
  </script>
  
  <style scoped>
  .base-checkbox {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  .base-checkbox input {
    position: absolute;
    opacity: 0;
  }
  .base-checkbox .checkmark {
    width: 1rem;
    height: 1rem;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 0.25rem;
    margin-right: 0.5rem;
    transition: background 0.2s, border-color 0.2s;
  }
  .base-checkbox input:checked + .checkmark {
    background: var(--color-primary, #007bff);
    border-color: var(--color-primary, #007bff);
  }
  </style>
  